import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import JobsListing from './JobsListing';

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } }
});

const JobsListingPage = () => (
  <QueryClientProvider client={queryClient}>
    <JobsListing />
  </QueryClientProvider>
);

export default JobsListingPage;
